import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';
import LanguageSync from './components/common/LanguageSync';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import ContactPage from './pages/ContactPage';
import BombWorldClassicPage from './pages/BombWorldClassicPage';
import BombWorldClassicPrivacyPage from './pages/BombWorldClassicPrivacyPage';
import BombWorldClassicTermsPage from './pages/BombWorldClassicTermsPage';
import InfinityBrainPage from './pages/InfinityBrainPage';
import InfinityBrainPrivacyPage from './pages/InfinityBrainPrivacyPage';
import InfinityBrainTermsPage from './pages/InfinityBrainTermsPage';
import PersonalPrizePage from './pages/PersonalPrizePage';
import PersonalPrizePrivacyPage from './pages/PersonalPrizePrivacyPage';
import PersonalPrizeTermsPage from './pages/PersonalPrizeTermsPage';
import PersonalVaultPage from './pages/PersonalVaultPage';
import PersonalVaultPrivacyPage from './pages/PersonalVaultPrivacyPage';
import PersonalVaultTermsPage from './pages/PersonalVaultTermsPage';
import PersonalContactPage from './pages/PersonalContactPage';
import PersonalContactPrivacyPage from './pages/PersonalContactPrivacyPage';
import PersonalContactTermsPage from './pages/PersonalContactTermsPage';
import WayHomePage from './pages/WayHomePage';
import WayHomePrivacyPage from './pages/WayHomePrivacyPage';
import WayHomeTermsPage from './pages/WayHomeTermsPage';
import PrivacyPage from './pages/PrivacyPage';
import OpenSourcePage from './pages/OpenSourcePage';
import ActivityHeatmapCalendarPage from './pages/ActivityHeatmapCalendarPage';
import NotFoundPage from './pages/NotFoundPage';
import { getRouterBasename } from './utils/lang';

function App(): JSX.Element {
  // basename is determined once at startup based on the URL path. When the
  // user switches language we navigate via window.location (full reload),
  // which re-runs this with the new basename. This way every internal
  // <Link to="/about"> automatically resolves to the correct language URL
  // without touching the existing call sites.
  const basename = getRouterBasename();

  return (
    <Router basename={basename}>
      <LanguageSync />
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:name" element={<NewsDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/bomb-world-classic" element={<BombWorldClassicPage />} />
          <Route path="/bomb-world-classic/privacy" element={<BombWorldClassicPrivacyPage />} />
          <Route path="/bomb-world-classic/terms" element={<BombWorldClassicTermsPage />} />
          <Route path="/infinity-brain" element={<InfinityBrainPage />} />
          <Route path="/infinity-brain/privacy" element={<InfinityBrainPrivacyPage />} />
          <Route path="/infinity-brain/terms" element={<InfinityBrainTermsPage />} />
          <Route path="/personal-prize" element={<PersonalPrizePage />} />
          <Route path="/personal-prize/privacy" element={<PersonalPrizePrivacyPage />} />
          <Route path="/personal-prize/terms" element={<PersonalPrizeTermsPage />} />
          <Route path="/personal-vault" element={<PersonalVaultPage />} />
          <Route path="/personal-vault/privacy" element={<PersonalVaultPrivacyPage />} />
          <Route path="/personal-vault/terms" element={<PersonalVaultTermsPage />} />
          <Route path="/personal-contact" element={<PersonalContactPage />} />
          <Route path="/personal-contact/privacy" element={<PersonalContactPrivacyPage />} />
          <Route path="/personal-contact/terms" element={<PersonalContactTermsPage />} />
          <Route path="/wayhome" element={<WayHomePage />} />
          <Route path="/wayhome/privacy" element={<WayHomePrivacyPage />} />
          <Route path="/wayhome/terms" element={<WayHomeTermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/open-source" element={<OpenSourcePage />} />
          <Route path="/open-source/activity-heatmap-calendar" element={<ActivityHeatmapCalendarPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
